<script lang="ts">
  import { goto } from '@roxi/routify'
  import NavigationButton from './NavigationButton.svelte'
</script>

<NavigationButton onClick={() => void $goto('/review/')} destination="/review/index"
  >Review Retros</NavigationButton
>
